<template>
  <span v-if="user">
    <!-- company if any -->
    <span v-if="user.getCompany() && !onlyName"
      >{{ user.getCompany() }}, &nbsp;</span
    >
    <!-- name -->
    <span>{{ user.getFullName() }}</span>
    <!-- mail if any -->
    <span v-if="user.getMail() && !onlyName">, {{ user.getMail() }}</span>
    <!-- birthdate if any -->
    <span v-if="user.getBirthdate() && !onlyName"
      >, {{ user.getBirthdate() | formatDate }}</span
    >
    <!-- city, if any -->
    <span v-if="user.getCity() && !onlyName"
      >&nbsp; {{ $t('shopBackendBookingDetail.fromCity') }}
      {{ user.getCity() }}</span
    >
  </span>
</template>

<script>
import User from '../../classes-shared/user/User'
import UserBookings from '../../classes-shared/bookings/UserBookings'

export default {
  name: 'DisplayUserHelper',
  props: {
    user: {
      type: [User, UserBookings],
      required: true,
      default: null,
    },

    // just display only the user's name
    onlyName: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
